import { render, staticRenderFns } from "./XShow.vue?vue&type=template&id=972e904a&scoped=true"
import script from "./XShow.vue?vue&type=script&lang=js"
export * from "./XShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e904a",
  null
  
)

export default component.exports